module.exports = __webpack_public_path__ + "img/pet stairs.ce334d16.png";